var _ellipse, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParkOutlineRectangularCircularConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 68,
    viewBox: "0 0 74 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 52,
    rx: 34.5,
    ry: 11.5,
    fill: "#D5EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.2917C26.6576 28.2917 28.2473 27.6332 29.4194 26.4611C30.5915 25.289 31.25 23.6993 31.25 22.0417C31.25 20.3841 30.5915 18.7944 29.4194 17.6223C28.2473 16.4502 26.6576 15.7917 25 15.7917C23.3424 15.7917 21.7527 16.4502 20.5806 17.6223C19.4085 18.7944 18.75 20.3841 18.75 22.0417C18.75 23.6993 19.4085 25.289 20.5806 26.4611C21.7527 27.6332 23.3424 28.2917 25 28.2917ZM30.2083 40.7917H19.7917V51.2084H30.2083V40.7917Z",
    fill: "white",
    stroke: "#D5EEFF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2493 22.0417H56.2494V46H38.541",
    stroke: "#D5EEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.2917C26.6576 28.2917 28.2473 27.6332 29.4194 26.4611C30.5915 25.289 31.25 23.6993 31.25 22.0417C31.25 20.3841 30.5915 18.7944 29.4194 17.6223C28.2473 16.4502 26.6576 15.7917 25 15.7917C23.3424 15.7917 21.7527 16.4502 20.5806 17.6223C19.4085 18.7944 18.75 20.3841 18.75 22.0417C18.75 23.6993 19.4085 25.289 20.5806 26.4611C21.7527 27.6332 23.3424 28.2917 25 28.2917ZM30.2083 40.7917H19.7917V51.2084H30.2083V40.7917Z",
    fill: "white",
    stroke: "#0593F5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2493 22.0417H56.2494V46H38.541",
    stroke: "#0593F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineRectangularCircularConnection);
export default __webpack_public_path__ + "static/media/icon-park-outline_rectangular-circular-connection.b27113b995201d03e2446d0d139900e3.svg";
export { ForwardRef as ReactComponent };